module.exports = __webpack_public_path__ + "img/system-tray.ae279ce2.jpeg";